import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { isEqual } from 'lodash';
import { MmuRemoteWidgetConfigurationDialog } from '../widget-configuration-dialog/mmu-remote-widget-configuration-dialog.component';
import { MmuDashboardWidget } from './mmu-dashboard-widget.directive';


/**
 * Dashboard Widgets should extend this class to share common functionality between widgets.
 */
@Directive()
export abstract class MmuRemoteDashboardWidget<C = unknown, R = void> extends MmuDashboardWidget<C, R> implements OnInit, OnDestroy {

  @ViewChild('configDialog')
  protected configDialog!: TemplateRef<unknown>;

  modal: NgbModalRef | null = null;
  configDialogInstance: MmuRemoteWidgetConfigurationDialog | null = null;

  @Input()
  /** The widget config that will be loaded and injected from the API. */
  set config(config: C) {
    if (!isEqual(this._config, config)) {
      this.restartPolling();
    } else {
      this._config = config;

      this.startPolling();
    }

    this._config = config;
  }

  @Output()
  readonly configChange = new EventEmitter<C>();

  /**
   * Emit the updated config object. On order to save updated configs this method needs to get called.
   *
   * @param c Record<string, any>
   * @protected
   */
  protected updateConfig(c: C): void {
    this.configChange.emit(c);
  }

  /**
   * To open a config dialog use this
   * @returns {Promise<void>}
   */
  async openConfigDialog(): Promise<void> {
    if (this.modalService) {
      this.modal = this.modalService.open(MmuRemoteWidgetConfigurationDialog);
      this.configDialogInstance = this.modal.componentInstance;

      /**
       * We're sure that this.configDialogInstance is set in L63, but to satisfy the typescript compiler
       * we need to check it here.
       */
      if (!this.configDialogInstance) {
        return Promise.reject(new Error('configDialogInstance is null'));
      }

      this.configDialogInstance.widgetName = this.title;
      this.configDialogInstance.content = this.configDialog;
      this.updateConfig(await this.modal.result);
    }
  }

  dismiss(): void {
    if (this.modal != null) {
      this.modal.dismiss();
    }
  }
}
